var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 13 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.004.016C2.694.016 0 2.215 0 4.917c0 2.42 2.136 4.449 5.021 4.834.196.042.462.13.53.297.06.152.039.386.018.544l-.082.513c-.022.151-.12.596.525.324.646-.27 3.46-2.052 4.721-3.51.863-.95 1.275-1.923 1.275-3.002 0-2.702-2.694-4.901-6.004-4.901zm-2.35 6.508H2.46c-.172 0-.315-.143-.315-.316v-2.4c0-.174.143-.318.315-.318.174 0 .315.144.315.317v2.084h.879c.174 0 .315.142.315.317 0 .173-.141.316-.315.316zm1.234-.316c0 .173-.141.316-.316.316-.172 0-.314-.143-.314-.316v-2.4c0-.174.142-.318.316-.318.173 0 .314.144.314.317v2.4zm2.872 0c0 .136-.087.256-.216.3-.032.01-.066.015-.1.015-.105 0-.195-.045-.255-.126L5.967 4.728v1.48c0 .172-.14.316-.316.316-.173 0-.313-.144-.313-.317v-2.4c0-.136.087-.256.215-.3.03-.01.068-.016.097-.016.098 0 .188.053.248.128L7.13 5.295V3.807c0-.173.141-.317.315-.317.173 0 .315.144.315.317v2.4zM9.69 4.69c.174 0 .314.144.314.318 0 .173-.14.317-.315.317h-.878v.566h.878c.175 0 .315.142.315.317 0 .173-.14.316-.315.316H8.495c-.172 0-.313-.143-.313-.316v-2.4c0-.174.14-.318.315-.318H9.69c.173 0 .313.144.313.317 0 .176-.14.317-.315.317h-.878v.566h.878z",
    transform: "translate(-1175 -5386) translate(0 5348) translate(1175.816 38)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineIcon);
export default __webpack_public_path__ + "static/media/line-icon.51c56403.svg";
export { ForwardRef as ReactComponent };